import { render, staticRenderFns } from "./ApproveActions.vue?vue&type=template&id=1f6aa0f2&"
import script from "./ApproveActions.vue?vue&type=script&lang=js&"
export * from "./ApproveActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports